import Heading from '@/components/Heading';
import Button from '@/components/Button';
import Code from '@/components/Code';

The `<LoadingOverlay />` component is a simple component that displays a loading overlay when the `isVisible` prop is `true`.

This component is _NOT_ meant to be used on its own, but rather as part of the [global overlay service](/docs/services/overlay-service/).

<Button className="btn-primary" onPress={props.showLoadingOverlay}>
  Show Loading Overlay
</Button>

<details open>
  <summary>Source Code</summary>

  <Code readOnly={true} language="tsx" value={`import eventService from '@/services/event';

  /* ... */

  const handleAsynCall = () => {
    eventService.emit('overlay:request-set-app-loading', true);

    someAsyncCall().finally(() => {
      eventService.emit('overlay:request-set-app-loading', false);
    });
  };`}
  />
</details>

<Heading level={2}>Event-Driven Architecture</Heading>

We use an event-driven approach for managing the loading overlay. Instead of directly rendering the loading overlay component, you emit events to show and hide the loading overlay.

This approach avoids extraneous page re-renders and ensures consistent loading overlay behavior across your application.
